module.exports = __webpack_public_path__ + "img/yff-banner.71204d85.png";